import React, { useEffect, useState } from 'react';
import { CardLoading } from '../card/CardLoading';
import * as globals from '../../globals'

export function ChatGpt(props) {

  const [outputText, setOutputText] = useState('')
  const [btnClicked, setBtnClicked] = useState()
  const [loading, setLoading] = useState(false)
  const inputText = props.inputText

    
  const callChatGpt = async () => {
    try {
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${globals.chatapiKey}`,
        },
        body: JSON.stringify({
          model: 'gpt-4o',
          messages: [
            { "role": "system", "content": "You must strictly follow instructions. Do not add explanations, introductions, or disclaimers. Only return the requested content. -return valid html 5, closed brackets" },
            { "role": "user", "content": `${props.inputText}` }
          ],
          max_tokens: 4000,
          frequency_penalty: 0.2,
          presence_penalty: 0.1,
          temperature: 0.4 //less creative in answers
        })
      })
      

      if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`)
      }

      const data = await response.json()

      if (!data.choices || !data.choices.length) {
        throw new Error('Invalid response structure from OpenAI')
      }

      setOutputText(data.choices[0].message.content || 'No response received')
          
    }
    catch (error) {
      console.error('Error fetching OpenAI API:', error)
      setOutputText('Error: Unable to get response from OpenAI')
    }
    finally {
      setBtnClicked(false)
    }
  }

  const handleClick = async () => {
    setLoading(true)
    setBtnClicked(true)
    await callChatGpt()
    setLoading(false)
  }

  const handleCopyClick = () => {
      const theText = outputText.replace(/<\/?[^>]+(>|$)/g, "")
      navigator.clipboard.writeText(theText)
          .then(() => {
              topBar.enqueueSnack({
                    id: parseInt(+new Date().getMilliseconds() + Math.random().toFixed()),
                    message: `Messages have been copied.`,
                    to: 3000,
                    success: true
                })
          })
          .catch(err => {
              topBar.enqueueSnack({
                    id: parseInt(+new Date().getMilliseconds() + Math.random().toFixed()),
                    message: `Messages failed to copy.`,
                    to: 3000,
                    success: false
                })
          })
  }
  


  return <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin:'10px 40px'}}>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom:10, width: '100%', height: 380, overflowY: 'auto' }}>
            { btnClicked ? <p style={{display:'flex',justifyContent:'center', alignItems:'center', fontSize:14}}>loading...</p> : null}  {/* <CardLoading loading={loading} reference={refLoader} />  */}
            { outputText ? 
              <button className='btn-copy' onClick={handleCopyClick} style={{alignSelf:'flex-end', height:40, fontSize:14 }}><i className='fal fa-clipboard'></i> Copy</button>
              : null
            }
        
            <div style={{margin:'20px 0', fontSize:14}} dangerouslySetInnerHTML={{ __html: outputText.replace(/```html|```/g, "").trim() }}></div>    
        </div>
        <div style={{height:40}}>
          <button className='btn drk borders' onClick={handleClick}>Generate Messages</button>
        </div>
  </div>
}


